/**
 * A function that emits a side effect and does not return anything.
 *
 *  thanks to https://github.com/chodorowicz/ts-debounce
 */
export type Procedure = (...args: any[]) => void;

export interface Options {
  isImmediate: boolean;
}

export function debounce<F extends Procedure>(
  func: F,
  waitMilliseconds: number = 50,
  options: Options = {
    isImmediate: false
  }
): F {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  return function(this: any, ...args: any[]): void {
    const doLater = () => {
      timeoutId = undefined;
      if (!options.isImmediate) {
        func.apply(this, args);
      }
    };

    const shouldCallNow = options.isImmediate && timeoutId === undefined;

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(doLater, waitMilliseconds);

    if (shouldCallNow) {
      func.apply(this, args);
    }
  } as any;
}
